import { IntegrationsGrid } from "@/components/integrations/integrations-grid";
import { useOutletContext } from "react-router-dom";

interface IntegrationsOutletContext {
  openEarlyAccess: (integrationName: string) => void;
  setOpenRequestDialog: (open: boolean) => void;
}

export default function IntegrationsMainPage() {
  const { openEarlyAccess, setOpenRequestDialog } =
    useOutletContext<IntegrationsOutletContext>();

  return (
    <IntegrationsGrid
      onEarlyAccess={openEarlyAccess}
      onRequestIntegration={() => setOpenRequestDialog(true)}
    />
  );
}
